import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from "@angular/core";
import {DateLevelEnum, DateLevelFormat, DateLevelZoom} from "./date-level-enum";
import {DxDateBoxComponent} from "devextreme-angular";

@Component({
  selector: 'yo-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: false
})
export class DatePickerComponent implements OnChanges {

  @ViewChild('dateBox') dateBox: DxDateBoxComponent;

  @Input() value: Date;
  @Input() selectLevel: DateLevelEnum = DateLevelEnum.DAY;
  @Input() displayLevel: DateLevelEnum;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Input() availableDates: Date[];
  @Input() allowManualEvents: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['availableDates'] && !changes['availableDates'].firstChange) {
      this.dateBox?.instance?.repaint();
    }
  }

  @Output() onValueChange: EventEmitter<Date> = new EventEmitter;

  protected readonly DateLevelFormat = DateLevelFormat;
  protected readonly DateLevelZoom = DateLevelZoom;

  isDateDisabled = ($event): boolean => {
    if (!this.availableDates || this.availableDates.length === 0) return false;
    const d = $event.date;
    return !this.availableDates.some(available => {
      switch (this.selectLevel) {
        case DateLevelEnum.YEAR:
          return available.getFullYear() === d.getFullYear();
        case DateLevelEnum.MONTH:
          return available.getFullYear() === d.getFullYear() && available.getMonth() === d.getMonth();
        case DateLevelEnum.DAY:
          return available.getFullYear() === d.getFullYear() && available.getMonth() === d.getMonth() && available.getDate() === d.getDate();
        default:
          return false;
      }
    });
  }

  onDateSelected = ($event) => {
    if (!!$event.event || this.allowManualEvents)
      this.onValueChange.emit($event.value);
  }
}
